import Layout from "./Layout.jsx";

import Home from "./Home";

import Market from "./Market";

import Accounts from "./Accounts";

import Procurement from "./Procurement";

import Signals from "./Signals";

import Segments from "./Segments";

import Playbooks from "./Playbooks";

import Admin from "./Admin";

import SegmentBuilder from "./SegmentBuilder";

import DataUploader from "./DataUploader";

import People from "./People";

import AccountFinal from "./AccountFinal";

import PersonProfile from "./PersonProfile";

import SegmentResults from "./SegmentResults";

import AlertSettings from "./AlertSettings";

import DataManagement from "./DataManagement";

import TempDataUpdate from "./TempDataUpdate";

import TempAccountFitUpload from "./TempAccountFitUpload";

import OrphanedPeopleCleanup from "./OrphanedPeopleCleanup";

import ClientNameUpload from "./ClientNameUpload";

import PeopleClientHistory from "./PeopleClientHistory";

import FixDemarqueMomentum from "./FixDemarqueMomentum";

import Landing from "./Landing";

import Auth from "./Auth";

import AuthCallback from "./AuthCallback";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";

import SettingsPersonalization from "./SettingsPersonalization";

import SettingsCommsSchedule from "./SettingsCommsSchedule";

import SettingsGmail from "./SettingsGmail";

import SettingsEvents from "./SettingsEvents";

import SettingsGmailCallback from "./SettingsGmailCallback";

import Settings from "./Settings";

import PlaybookPreview from "./PlaybookPreview";

import Outbox from "./Outbox";

import Analytics from "./Analytics";

import DIYPlaybook from "./DIYPlaybook";

import EventPlaybookPreview from "./EventPlaybookPreview";

import SettingsProfile from "./SettingsProfile";

import SettingsLanguage from "./SettingsLanguage";

import SettingsOutlook from "./SettingsOutlook";

import SettingsOutlookCallback from "./SettingsOutlookCallback";

import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useHomeDestination, isHomePath } from '@/hooks/useHomeDestination';

const PAGES = {
    
    Home: Home,
    
    Market: Market,
    
    Accounts: Accounts,
    
    Procurement: Procurement,
    
    Signals: Signals,
    
    Segments: Segments,
    
    Playbooks: Playbooks,
    
    Admin: Admin,
    
    SegmentBuilder: SegmentBuilder,
    
    DataUploader: DataUploader,
    
    People: People,
    
    AccountFinal: AccountFinal,
    
    PersonProfile: PersonProfile,
    
    SegmentResults: SegmentResults,
    
    AlertSettings: AlertSettings,
    
    DataManagement: DataManagement,
    
    TempDataUpdate: TempDataUpdate,
    
    TempAccountFitUpload: TempAccountFitUpload,
    
    OrphanedPeopleCleanup: OrphanedPeopleCleanup,
    
    ClientNameUpload: ClientNameUpload,
    
    PeopleClientHistory: PeopleClientHistory,
    
    FixDemarqueMomentum: FixDemarqueMomentum,
    
    Landing: Landing,
    
    Auth: Auth,
    
    AuthCallback: AuthCallback,
    ForgotPassword: ForgotPassword,
    ResetPassword: ResetPassword,
    
    SettingsPersonalization: SettingsPersonalization,
    
    SettingsCommsSchedule: SettingsCommsSchedule,
    
    SettingsGmail: SettingsGmail,
    
    SettingsEvents: SettingsEvents,
    
    SettingsGmailCallback: SettingsGmailCallback,
    
    Settings: Settings,
    
    PlaybookPreview: PlaybookPreview,
    
    Outbox: Outbox,
    
    Analytics: Analytics,
    
    DIYPlaybook: DIYPlaybook,
    
    EventPlaybookPreview: EventPlaybookPreview,
    
    SettingsProfile: SettingsProfile,
    
    SettingsLanguage: SettingsLanguage,
    
    SettingsOutlook: SettingsOutlook,
    
    SettingsOutlookCallback: SettingsOutlookCallback,
    
}

function _getCurrentPage(url) {
    if (url.endsWith('/')) {
        url = url.slice(0, -1);
    }
    let urlLastPart = url.split('/').pop();
    if (urlLastPart.includes('?')) {
        urlLastPart = urlLastPart.split('?')[0];
    }

    const pageName = Object.keys(PAGES).find(page => page.toLowerCase() === urlLastPart.toLowerCase());
    return pageName || Object.keys(PAGES)[0];
}

function HomeOrMarket() {
    const location = useLocation();
    return <HomeOrMarketCheck key={location.key} />;
}

function HomeOrMarketCheck() {
    const { loading, redirectTo } = useHomeDestination();
    if (loading) return null;
    if (redirectTo) return <Navigate to={redirectTo} replace />;
    return <Home />;
}

function HomeDestinationGate({ children }) {
    const { pathname } = useLocation();
    const { loading, redirectTo } = useHomeDestination();
    if (isHomePath(pathname)) {
        if (loading) return null;
        if (redirectTo) return <Navigate to={redirectTo} replace />;
    }
    return children;
}

// Create a wrapper component that uses useLocation inside the Router context
function PagesContent() {
    const location = useLocation();
    const currentPage = _getCurrentPage(location.pathname);
    
    return (
        <Layout currentPageName={currentPage}>
            <HomeDestinationGate>
            <Routes>            
                
                    <Route path="/" element={<Landing />} />
                
                <Route path="/Auth" element={<Landing />} />
                
                <Route path="/Home" element={<HomeOrMarket />} />
                
                <Route path="/Market" element={<Market />} />
                
                <Route path="/Accounts" element={<Accounts />} />
                
                <Route path="/Procurement" element={<Procurement />} />
                
                <Route path="/Signals" element={<Signals />} />
                
                <Route path="/Segments" element={<Segments />} />
                
                <Route path="/Playbooks" element={<Playbooks />} />
                
                <Route path="/Admin" element={<Admin />} />
                
                <Route path="/SegmentBuilder" element={<SegmentBuilder />} />
                
                <Route path="/DataUploader" element={<DataUploader />} />
                
                <Route path="/People" element={<People />} />
                
                <Route path="/AccountFinal" element={<AccountFinal />} />
                
                <Route path="/PersonProfile" element={<PersonProfile />} />
                
                <Route path="/SegmentResults" element={<SegmentResults />} />
                
                <Route path="/AlertSettings" element={<AlertSettings />} />
                
                <Route path="/DataManagement" element={<DataManagement />} />
                
                <Route path="/TempDataUpdate" element={<TempDataUpdate />} />
                
                <Route path="/TempAccountFitUpload" element={<TempAccountFitUpload />} />
                
                <Route path="/OrphanedPeopleCleanup" element={<OrphanedPeopleCleanup />} />
                
                <Route path="/ClientNameUpload" element={<ClientNameUpload />} />
                
                <Route path="/PeopleClientHistory" element={<PeopleClientHistory />} />
                
                <Route path="/FixDemarqueMomentum" element={<FixDemarqueMomentum />} />
                
                <Route path="/Landing" element={<Landing />} />
                
                <Route path="/Auth" element={<Auth />} />
                
                <Route path="/AuthCallback" element={<AuthCallback />} />
                <Route path="/ForgotPassword" element={<ForgotPassword />} />
                <Route path="/ResetPassword" element={<ResetPassword />} />
                
                <Route path="/SettingsPersonalization" element={<SettingsPersonalization />} />
                
                <Route path="/SettingsCommsSchedule" element={<SettingsCommsSchedule />} />
                
                <Route path="/SettingsGmail" element={<SettingsGmail />} />
                
                <Route path="/SettingsEvents" element={<SettingsEvents />} />
                
                <Route path="/SettingsGmailCallback" element={<SettingsGmailCallback />} />
                
                <Route path="/Settings" element={<Settings />} />
                
                <Route path="/PlaybookPreview" element={<PlaybookPreview />} />
                
                <Route path="/Outbox" element={<Outbox />} />
                
                <Route path="/Analytics" element={<Analytics />} />
                
                <Route path="/DIYPlaybook" element={<DIYPlaybook />} />
                
                <Route path="/EventPlaybookPreview" element={<EventPlaybookPreview />} />
                
                <Route path="/SettingsProfile" element={<SettingsProfile />} />
                
                <Route path="/SettingsLanguage" element={<SettingsLanguage />} />
                
                <Route path="/SettingsOutlook" element={<SettingsOutlook />} />
                
                <Route path="/SettingsOutlookCallback" element={<SettingsOutlookCallback />} />
                
            </Routes>
            </HomeDestinationGate>
        </Layout>
    );
}

export default function Pages() {
    return (
        <Router>
            <PagesContent />
        </Router>
    );
}